/**  Класс для сообщения из чата */
export class SMSPacket {
  /** Можно ли выбирать */
  public BankSet: string = "";

  /** Название */
  public Title: string = "";

  /** VIP */
  public Vip: string = "";

  /** Code */
  public Code: string = "";

  /**
   * Конструктор с загрузкой данных из ответа сервера.
   * @param src данные с сервера
   */
  constructor(src: any) {
    if (src) {
      for (const key in this) this[key] = src[key] ?? "";
    }
  }
}
